
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"checkbox-radio-input checkbox-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(checkboxRadioInputValue),expression:"checkboxRadioInputValue"}],attrs:{"name":name,"type":"radio"},domProps:{"value":label,"checked":_q(checkboxRadioInputValue,label)},on:{"change":function($event){checkboxRadioInputValue=label}}}),_c('label',{attrs:{"for":name}},[_c('div',{staticClass:"checkbox"}),_v(_s(label))])])}},
      staticRenderFns: []
    };
  